// prettier-ignore
import * as React from 'react'
import { LandingView } from './Landing.view'

export const Landing = () => {
  return <LandingView />
}
